import React, { useEffect, useState, useRef } from 'react';

const ScrollingTab = ({ children }) => {
  const tabsRef = useRef(null); // Ref for the tabs container
  const [isPrevDisabled, setIsPrevDisabled] = useState(true);
  const [isNextDisabled, setIsNextDisabled] = useState(false);

  // Function to scroll tabs
  const scrollTabs = (direction) => {
    if (tabsRef.current) {
      const tabContainer = tabsRef.current;
      const scrollAmount = 200; // Scroll amount (adjust as needed)
      const currentScroll = tabContainer.scrollLeft;
      tabContainer.scrollTo({
        left: direction === 'next' ? currentScroll + scrollAmount : currentScroll - scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  // Determine if the scroll container is at the start or the end
  const isAtStart = () => tabsRef.current?.scrollLeft === 0;
  const isAtEnd = () => tabsRef.current?.scrollWidth - tabsRef.current?.clientWidth === tabsRef.current?.scrollLeft;

  // Handle scroll events to disable/enable buttons
  const handleScroll = () => {
    if (tabsRef.current) {
      setIsPrevDisabled(isAtStart());
      setIsNextDisabled(isAtEnd());
    }
    // eslint-disable-next-line
  };

  // Handle resize events to adjust the button visibility
  const handleResize = () => {
    if (tabsRef.current) {
      handleScroll(); // Re-check if the buttons should be disabled/visible
    }
  };

  useEffect(() => {
    const tabContainer = tabsRef.current;

    if (tabContainer) {
      // Add scroll event listener
      tabContainer.addEventListener('scroll', handleScroll);

      // Add mouse wheel listener
      const handleWheel = (event) => {
        event.preventDefault(); // Prevent page scroll
        if (event.deltaY !== 0) {
          scrollTabs(event.deltaY > 0 ? 'next' : 'prev');
        }
      };
      tabContainer.addEventListener('wheel', handleWheel, { passive: false });

      // Initial check for the state of the buttons (after the component mounts)
      handleScroll();

      // Add resize event listener
      window.addEventListener('resize', handleResize);

      return () => {
        tabContainer.removeEventListener('scroll', handleScroll);
        tabContainer.removeEventListener('wheel', handleWheel);
        window.removeEventListener('resize', handleResize); // Clean up resize event listener
      };
    }
    // eslint-disable-next-line
  }, []);

  // Trigger handleScroll on mount to ensure buttons are visible after the first render
  useEffect(() => {
    handleScroll();
    // eslint-disable-next-line
  }, [children]); // Run this whenever children change (e.g., on page load or children updates)

  return (
    <div className='scrolling-tabs'>
      <button className='scrolling-btn prev-btn' onClick={() => scrollTabs('prev')} disabled={isPrevDisabled}></button>
      <div className='overflow-auto' ref={tabsRef}>
        {children}
      </div>
      <button className='scrolling-btn next-btn' onClick={() => scrollTabs('next')} disabled={isNextDisabled}></button>
    </div>
  );
};

export default ScrollingTab;
